import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  StateModel,
  StateModel_Registrierung_Suchvorschlag,
} from '../../redux/store';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import InputFieldText from '../../components/input/floating-label/input-field/InputFieldText';
import Button, { ButtonType } from '../../components/button/Button';
import Toolbar from '../../components/toolbar/Toolbar';
import { resetBenutzererfassung } from '../../redux/actions/benutzererfassung';
import { Adresse, Benutzer, Benutzerversion, Sprache } from '../../api';
import Select from '../../components/select/Select';
import { benutzerVersionen } from '../tms/benutzererfassung/Benutzererfassung';
import GridCellWrapper from '../../components/grid-cell-wrapper/GridCellWrapper';
import { emptyAdresse } from '../tms/auftragserfassung/adresse/AdresseTypen';
import {
  getRegLaender,
  getRegOrte,
  getRegSprachen,
  register,
} from '../../redux/actions/register';
import { AutocompleteFormatPLZ } from '../tms/adresserfassung/anschrift/search/AutocompleteFormatPLZ';
import { AutocompleteFormatOrtsname } from '../tms/adresserfassung/anschrift/search/AutocompleteFormatOrtsname';
import { clearSuchvorschlaege } from '../../redux/actions/adresse';
import { History } from 'history';
import { toSelectOptions } from '../../components/select/SelectModel';
import { nameof } from '../../utils/objectUtils';
import { ConfigModel } from '../../models/ConfigModel';
import { removeNotifications } from '../../utils/notificationUtils';

export interface RegistrierungProps {
  ortSuchvorschlaege: StateModel_Registrierung_Suchvorschlag[];
  clearSuchvorschlaege: () => void;
  register: (benutzer: Benutzer, history: History) => void;
  getRegSprachen: () => void;
  sprachen: Sprache[];
  getRegLaender: () => void;
  laender: string[];
  getRegOrte: (lkz: string, plzOrOrtsname: string) => void;
  config: ConfigModel;
}

const Registrierung = (props: RegistrierungProps & RouteComponentProps) => {
  const [plzOrtEnabled, setPlzOrtEnabled] = useState<boolean>(false);
  const [mandant, setMandant] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [versionId, setVersionId] = useState<number>(1);
  const [spracheId, setSpracheId] = useState<number>(50);
  const [password, setPassword] = useState<string>('');
  const [passwordRepeat, setPasswordRepeat] = useState<string>('');
  const [adresse, setAdresse] = useState<Adresse>(emptyAdresse);
  const [tooltipKundennummer, setTooltipKundennummer] = useState<string>('');
  const isBexity = props.config.clientKunde?.toUpperCase() === 'BEXITY';
  const minLenghtPW = !props.config.clientMinLengthPw
    ? isBexity
      ? 12
      : 8
    : props.config.clientMinLengthPw;
  const pwHint =
    'Bitte mindestens ' +
    minLenghtPW +
    ', max. 25Zeichen, einen Großbuchstaben, eine Zahl und ein Sonderzeichen eingeben';
  const pwLabel =
    'Benutzer Passwort (min. ' +
    minLenghtPW +
    ', max. 25 Zeichen, eine Zahl, einen Großbuchstaben und ein Sonderzeichen)';
  useEffect(() => {
    props.getRegSprachen();
    props.getRegLaender();
  }, []);

  useEffect(() => {
    setTooltipKundennummer(
      props.config.clientKunde
        ? 'Bitte geben Sie hier Ihre ' +
            props.config.clientKunde +
            ' Kundennummer ein.'
        : 'Bitte geben Sie hier Ihre Kundennummer ein.'
    );
  }, [props.config.clientKunde]);

  useEffect(() => {
    const htmlConfirm_password = document.getElementById(
      'userpasswordrepeat'
    ) as HTMLObjectElement;
    if (password !== passwordRepeat) {
      htmlConfirm_password?.setCustomValidity(
        'Die Passwörter sind nicht identisch.'
      );
    } else {
      htmlConfirm_password?.setCustomValidity('');
    }
  }, [password, passwordRepeat]);

  useEffect(() => {
    //#84067 Passwort prüfen
    const html_password = document.getElementById(
      'userpassword'
    ) as HTMLObjectElement;
    if (!checkPassword(password)) {
      html_password?.setCustomValidity(pwHint);
    } else {
      html_password?.setCustomValidity('');
    }
  }, [password]);

  const checkPassword = (value: string) => {
    //#84067 Passwort mindestanforderung
    if (value != null) {
      if (!/[0-9]/.test(value)) return false; //Zahl?
      if (value.toLowerCase() == value) return false; //Großbuchstabe?
      if (!/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)) return false; //Sonderzeichen?
      if (value.length < minLenghtPW || value.length > 25) return false; //LängeOK?
      return true;
    }
    return false;
  };

  const reset = () => {
    setMandant('');
    setUsername('');
    setEmail('');
    setVersionId(1);
    setSpracheId(50);
    setPassword('');
    setPasswordRepeat('');
    setAdresse(emptyAdresse);
  };

  const buildBenutzerPayload = (): Benutzer => {
    removeNotifications();
    const benutzer: Benutzer = {
      owningMandant: { name: mandant, adresse: adresse },
      name: username,
      email: email,
      password: password,
      benutzerversion: {
        id: versionId,
      },
      sprache: {
        id: spracheId,
      },
    };
    return benutzer;
  };

  const autocompleteHandlerPlzOrt = (
    suchvorschlag: StateModel_Registrierung_Suchvorschlag
  ) => {
    setAdresse({
      ...adresse,
      ort: suchvorschlag.ortsname,
      plz: suchvorschlag.plz,
    });
    props.clearSuchvorschlaege();
  };

  const plzChangeHandler = (value: string) => {
    if (adresse.lkz && value) props.getRegOrte(adresse.lkz, value);
    setAdresse({ ...adresse, plz: value });
    props.clearSuchvorschlaege();
  };

  const ortChangeHandler = (value: string) => {
    if (adresse.lkz && value) props.getRegOrte(adresse.lkz, value);
    setAdresse({ ...adresse, ort: value });
    props.clearSuchvorschlaege();
  };

  const landChangeHandler = (id?: number) => {
    if (id) {
      const land = props.laender[id];
      if (land) {
        //LKZ ausgewählt
        setAdresse({
          ...adresse,
          lkz: land,
          land: { id: id, lkz: land, bezeichnung: land },
        });
        setPlzOrtEnabled(true);
      } else {
        //Leereintrag ausgewählt
        setAdresse({
          ...adresse,
          land: { id: undefined, lkz: '', bezeichnung: '' },
          lkz: '',
          plz: '',
          ort: '',
        });
        setPlzOrtEnabled(false);
      }
    }
  };

  return (
    <form
      autoComplete={'off'}
      onSubmit={e => {
        e.preventDefault();
        props.register(buildBenutzerPayload(), props.history);
        //Close() entfernt
      }}
    >
      <div className='wrapper-registrierung'>
        <Toolbar>
          <Button
            tooltip={'Speichern'}
            key={0}
            classes={'iconButton'}
            type={ButtonType.submit}
          >
            <i className='far fa-save fa-2x' />
          </Button>
          <Button
            tooltip='Abbrechen'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => props.history.push('/')}
          >
            <i className='fas fa-times fa-2x color-red' />
          </Button>
        </Toolbar>
        <GridCellWrapper
          classes='benutzer'
          label='Benutzer'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <div id='user-mandant'>
            <InputFieldText
              id={'mandant'}
              label='Name/Beschreibung des Mandanten z.B. Raiffeisen Salzburg'
              name='mandant'
              classes={'noSelect'}
              onChangeHandler={setMandant}
              value={mandant}
              maxlength={35}
              required
            />
          </div>
          <div id='username-email'>
            <InputFieldText
              id={'username'}
              label='Benutzername'
              name='username'
              classes={'noSelect'}
              maxlength={30}
              onChangeHandler={setUsername}
              value={username}
              required
            />
            <InputFieldText
              label='E-Mail'
              name='email'
              classes='email'
              onChangeHandler={setEmail}
              value={email}
              inputType={'email'}
              required
            />
          </div>
          <div id='password-passwordrepeat'>
            <InputFieldText
              id={'userpassword'}
              label={pwLabel}
              tooltip={pwLabel}
              name='userpassword'
              classes='userpassword'
              onChangeHandler={setPassword}
              value={password}
              inputType={'password'}
              required
            />
            <InputFieldText
              id={'userpasswordrepeat'}
              label='Benutzer Passwort bestätigen'
              name='userpasswordrepeat'
              classes='userpasswordrepeat'
              onChangeHandler={setPasswordRepeat}
              value={passwordRepeat}
              inputType={'password'}
              required
            />
          </div>
          <div>
            <Select
              className='sprache'
              headerTitle='Sprache'
              selectedOptionId={spracheId}
              onChangeHandler={value => setSpracheId(value ?? 50)}
              selectData={toSelectOptions(
                props.sprachen,
                nameof<Sprache>('bezeichnung'),
                false
              )}
            />
          </div>
          <div>
            <Select
              className='version'
              headerTitle='Version'
              selectedOptionId={versionId}
              onChangeHandler={value => setVersionId(value ?? 1)}
              selectData={toSelectOptions(
                benutzerVersionen(),
                nameof<Benutzerversion>('name'),
                false
              )}
            />
          </div>
        </GridCellWrapper>
        <GridCellWrapper
          classes='kundendaten'
          label='Kundendaten'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <InputFieldText
            label={tooltipKundennummer}
            name='kundennummer'
            classes='adr-kundennr'
            value={adresse.fremdnummer}
            inputType={isBexity ? 'number' : 'text'}
            maxlength={20}
            onChangeHandler={value =>
              setAdresse({ ...adresse, fremdnummer: value })
            }
            required
          />
          <InputFieldText
            label='Name'
            name='name'
            classes='adr-name'
            value={adresse ? adresse.name ?? '' : ''}
            maxlength={35}
            onChangeHandler={value => setAdresse({ ...adresse, name: value })}
            required
          />
          <div id='adr-zeile2-zeile3'>
            <InputFieldText
              label='Namenzusatz 2'
              name='zeile2'
              classes='adr-zeile2'
              value={adresse.zeile2}
              maxlength={35}
              onChangeHandler={value =>
                setAdresse({ ...adresse, zeile2: value })
              }
            />
            <InputFieldText
              label='Namenzusatz 3'
              name='zeile3'
              classes='adr-zeile3'
              value={adresse.zeile3}
              maxlength={35}
              onChangeHandler={value =>
                setAdresse({ ...adresse, zeile3: value })
              }
            />
          </div>
        </GridCellWrapper>
        <GridCellWrapper
          classes='anschrift'
          label='Anschrift'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <div id='adr-lkz-plz-ort'>
            <Select
              className='adr-lkz'
              headerTitle='LKZ'
              onChangeHandler={landChangeHandler}
              selectedOptionId={adresse?.land?.id}
              selectData={props.laender.map((land, index) => {
                return {
                  elementId: index,
                  id: index,
                  value: land ?? '',
                };
              })}
            />
            <InputFieldText
              readonly={!plzOrtEnabled}
              required={true}
              label='PLZ'
              name='plz'
              classes='adr-plz'
              value={adresse.plz}
              maxlength={9}
              onChangeHandler={plzChangeHandler}
              autocompleteFormat={<AutocompleteFormatPLZ />}
              autocompleteHandler={autocompleteHandlerPlzOrt}
              suchvorschlaege={props.ortSuchvorschlaege}
            />
            <InputFieldText
              readonly={!plzOrtEnabled}
              required={true}
              label='Ort'
              name='ort'
              classes='adr-ort'
              value={adresse.ort}
              maxlength={35}
              onChangeHandler={ortChangeHandler}
              autocompleteFormat={<AutocompleteFormatOrtsname />}
              autocompleteHandler={autocompleteHandlerPlzOrt}
              suchvorschlaege={props.ortSuchvorschlaege}
            />
          </div>
          <InputFieldText
            label='Ortsteil'
            name='ortsteil'
            classes='adr-ortsteil'
            value={adresse.ortsteil}
            maxlength={35}
            onChangeHandler={value =>
              setAdresse({ ...adresse, ortsteil: value })
            }
          />
          <div id='adr-strasse-haus-nr'>
            <InputFieldText
              required={true}
              label='Strasse'
              name='strasse'
              classes='adr-strasse'
              value={adresse.strasse}
              maxlength={35}
              onChangeHandler={value =>
                setAdresse({ ...adresse, strasse: value })
              }
            />
            <InputFieldText
              label='Hausnummer'
              name='hausnummer'
              classes='adr-haus-nr'
              value={adresse.hausnummer}
              maxlength={10}
              onChangeHandler={value =>
                setAdresse({ ...adresse, hausnummer: value })
              }
            />
          </div>
          <InputFieldText
            label='Zusatz'
            name='zusatz'
            classes='adr-zusatz'
            value={adresse.zusatz}
            maxlength={5}
            onChangeHandler={value => setAdresse({ ...adresse, zusatz: value })}
          />
        </GridCellWrapper>
        <GridCellWrapper
          classes='kontakt'
          label='Kontakt'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <div id='adr-kontakt-telefon'>
            <InputFieldText
              label='Kontakt'
              name='kontakt'
              classes='adr-kontakt'
              value={adresse.kontakt}
              maxlength={100}
              onChangeHandler={value =>
                setAdresse({ ...adresse, kontakt: value })
              }
            />
            <InputFieldText
              label='Telefon'
              name='telefon'
              classes='adr-telefon'
              inputType='tel'
              value={adresse.telefon}
              onChangeHandler={value =>
                setAdresse({ ...adresse, telefon: value })
              }
            />
          </div>
        </GridCellWrapper>
      </div>
    </form>
  );
};
const mapStateToProps = (state: StateModel) => ({
  sprachen: state.Stammdaten.sprachen,
  laender: state.Registrierung.laender,
  ortSuchvorschlaege: state.Registrierung.suchvorschlaege,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getRegSprachen,
  getRegLaender,
  getRegOrte,
  register,
  resetBenutzererfassung,
  clearSuchvorschlaege,
})(withRouter(Registrierung));
